import React from "react";
import { Flex, Heading, Box, Text } from "theme-ui";
import PropTypes from "prop-types";
import { typography, colors } from "@greythr/shared-components";
import ShareSection from "./ShareSection";

const Header = ({
  title,
  subTitle,
  customStyles,
  url,
  imageSrc,
  description,
  author,
  timeToRead,
}) => {
  return (
    <Flex>
      <Flex sx={{ gap: "1.5rem", flexDirection: "column", ...customStyles }}>
        <Heading
          as="h1"
          sx={{
            ...typography.h1,
          }}
        >
          {title}
        </Heading>
        <Heading as="h3" sx={{ ...typography.h3, color: colors.neutral600 }}>
          {subTitle}
        </Heading>
        {author && (
          <Flex
            sx={{
              mb: [0, 0, 0, "1.5rem"],
            }}
          >
            <Box as="h6" sx={{ ...typography.h6, pr: "0.75rem" }}>
              By{" "}
              <Text
                sx={{ color: colors.primary700 }}
              >{`${author?.firstName}`}</Text>
            </Box>
            {timeToRead && (
              <Box
                sx={{
                  ...typography.h7,
                  borderLeft: `1px solid ${colors.neutral900}`,
                  pl: "0.75rem",
                }}
              >{`${timeToRead} minute read`}</Box>
            )}
          </Flex>
        )}
        <ShareSection
          imageSrc={imageSrc}
          url={url}
          description={description}
          title={title}
        />
      </Flex>
    </Flex>
  );
};

Header.propTypes = {
  title: PropTypes.string,
  subTitle: PropTypes.string,
  sx: PropTypes.object,
  url: PropTypes.string.isRequired,
  imageSrc: PropTypes.string.isRequired,
  description: PropTypes.string,
};

Header.defaultProps = {
  title: "title",
  subTitle: "subTitle",
  sx: {},
  url: "url here",
  imageSrc: "image url here",
  description: "",
};

export default Header;
